export default __webpack_public_path__ + "static/media/chevron.9b64349b.svg";